"use client"
import { useState } from "react";
import { postCommentService, replyCommentService, likeCommentService, dislikeCommentService, deleteCommentService } from "@/services/comment";
import { fetchComments as fetchCommentsService, fetchCommentReplies as fetchCommentRepliesService } from "@/services/comment"
import { addToast } from "@heroui/react";
import { useUserInfoStore } from "@/models/userInfo";
import useDocStore from "@/models/doc";
import { useCommentActions, useCommentSelectors } from "@/models/comment";
import { nanoid } from "nanoid";

const COMMENT_COUNT = 50;
const REPLY_COUNT = 20;
export const useComment = (docid: string, qualityComments: any[] = []) => {
    const {
        deleteReply: deleteReplyAction,
        deleteComment: deleteCommentAction,
        addComment: addCommentAction,
        addHotComments: addHotCommentsAction,
        addNewComments: addNewCommentsAction,
        addReply: addReplyAction,
        setReplyList: setReplyListAction,
        updateComment: updateCommentAction,
        updateReply: updateReplyAction,
        clearComments: clearCommentsAction,
        setHotComments: setHotCommentsAction,
        setNewComments: setNewCommentsAction,
    } = useCommentActions();
    const { getCommentById, getReplyById, hotComments, newComments } = useCommentSelectors();
    const { userInfo } = useUserInfoStore();
    const { doc } = useDocStore();
    // const [comments, setComments] = useState<Comment[]>([]);
    function getUserInfo() {
        return {
            media_id: userInfo.userid,
            user_id: userInfo.userid,
            profile: userInfo.profile_url,
            nickname: userInfo.nickname,
        }
    }
    function postComment(comment: string, images?: string[]) {
        const params = {
            docid: docid,
            comment,
            images: images || [],
            media_id: userInfo.userid,
            user_id: userInfo.userid,
            profile: userInfo.profile_url,
            nickname: userInfo.nickname,
        }
        console.log("🚀 ~ postComment ~ params:", params)
        postCommentService(params).then((res: any) => {
            if (res.code == 0) {
                console.log("🚀 ~ postCommentService ~ res:", res.comment)
                addToast({
                    title: "Comment posted successfully",
                    color: "success",
                });
                // setComments((pre: Comment[]) => [{ ...res.comment, mine: true }, ...pre]);
                addCommentAction({ ...res.comment, mine: true })
            } else {
                addToast({
                    title: `Failed to post comments: ${res.code} ${res.message}`,
                });
            }
        });
    }
    function replyComment(reply: string, comment: string, images?: {
        url: string;
        width: number;
        height: number;
    }[], parent_id?: string) {
        const params = {
            docid: docid,
            comment,
            reply,
            images: images || [],
            ...getUserInfo()
        }
        console.log("🚀 ~ postComment ~ params:", params)
        return replyCommentService(params).then((res: any) => {
            if (res.code == 0) {
                addToast({
                    title: "Comment posted successfully",
                    color: "success",
                });

                addReplyAction(parent_id || reply, { ...res.comment, mine: true })
                // return res.comment;
            } else {
                addToast({
                    title: `Failed to post comments: ${res.code} ${res.message}`,
                    color: "danger",
                });
                return null;
            }
        });
    }
    function likeComment(comment_id: string) {
        const params = {
            comment_id,
            ...getUserInfo()
        }
        const comment = getCommentById(comment_id)
        if (comment) {
            updateCommentAction(comment_id, {
                like: comment.like + 1
            })
        }
        return likeCommentService(params);
    }
    function dislikeComment(comment_id: string) {
        const params = {
            comment_id,
            ...getUserInfo()
        }
        const comment = getCommentById(comment_id)
        if (comment) {
            updateCommentAction(comment_id, {
                dislike: comment.dislike + 1
            })
        }
        return dislikeCommentService(params);
    }
    function deleteComment(comment_id: string) {
        const params = {
            comment_id,
            docid: docid,
            ...getUserInfo()
        }
        deleteCommentAction(comment_id)
        return deleteCommentService(params);
    }
    function deleteReply(comment_id: string, reply_id: string) {
        const params = {
            reply_id,
            docid: docid,
            ...getUserInfo()
        }
        deleteReplyAction(comment_id, reply_id)
        return deleteCommentService(params);
    }
    const [showMoreComment, setShowMoreComment] = useState(true);
    const [commentLoading, setCommentLoading] = useState(true);
    function fetchComments() {
        setCommentLoading(true);
        return fetchCommentsService({ docid: docid, count: COMMENT_COUNT }).then((res: any) => {
            checkShowMoreComment(res?.comments || [])
            const hotComments = res?.hot_comments || []
            const qualityCommentsIds = qualityComments.map((item: any) => item.comment_id) || []
            setHotCommentsAction(hotComments.sort((a: any, b: any) => {
                const aIndex = qualityCommentsIds.indexOf(a.comment_id)
                const bIndex = qualityCommentsIds.indexOf(b.comment_id)
                if (aIndex === -1 && bIndex === -1) {
                    return 0
                }
                if (aIndex === -1) {
                    return 1
                }
                if (bIndex === -1) {
                    return -1
                }
                return aIndex - bIndex
            }))
            setNewCommentsAction(res?.comments || [])
        }).finally(() => {
            setCommentLoading(false);
        })
    }
    function fetchMoreComments(last_comment_id: string) {
        if (!last_comment_id) {
            return;
        }
        return fetchCommentsService({ docid, count: COMMENT_COUNT, last_comment_id }).then((res: any) => {
            checkShowMoreComment(res?.comments || [])
            addNewCommentsAction(res?.comments || [])
            addHotCommentsAction(res?.hot_comments || res?.comments || [])
        })
    }
    function checkShowMoreComment(comments: Comment[]) {
        if (comments?.length === 0 || !comments) {
            setShowMoreComment(false);
        }
        // if (comments?.length < COMMENT_COUNT) {
        //     setShowMoreComment(false);
        // }
    }
    function fetchMoreReply(comment_id: string, reply_id: string) {
        const last_reply_id = reply_id;
        if (!last_reply_id) {
            return;
        }
        return fetchCommentRepliesService({ docid, count: REPLY_COUNT, last_reply_id, comment_id }).then((res: any) => {
            if (res?.comment?.replies?.length > 0) {
                setReplyListAction(comment_id, res?.comment?.replies)
            } else {
                // updateCommentAction(comment_id, {
                //     //@ts-ignore
                //     type: 'NO_MORE_REPLY',
                // })
                const last_reply: any = getReplyById(comment_id, reply_id)
                console.log("🚀 ~ returnfetchCommentRepliesService ~ last_reply:", last_reply)
                addReplyAction(comment_id, {
                    ...last_reply,
                    reply_id: nanoid(),
                    comment: '___NO_MORE_REPLY__',
                })
            }
        })
    }
    return {
        hotComments,
        newComments,
        postComment,
        replyComment,
        likeComment,
        dislikeComment,
        deleteComment,
        deleteReply,
        clearComments: clearCommentsAction,
        fetchComments,
        fetchMoreComments,
        fetchMoreReply,
        showMoreComment,
        commentLoading,
    };
}
